export default "__VITE_ASSET__23bd7526__"